import React, { useState } from "react";

const ThreeDModal = ({ url, title, imageUrl }) => {
  const [modal, openModal] = useState(false);

  function handleKeyClick(e) {
    if (modal && e.keyCode === 27) {
      openModal(false);
    }
  }

  return (
    <div className="relative w-full h-full" onKeyDown={handleKeyClick}>
      <model-viewer
        src={url}
        poster={imageUrl}
        shadow-intensity="1"
        ar
        camera-controls
        touch-action="pan-y"
        alt={title}
      ></model-viewer>
      <button
        onClick={() => openModal(true)}
        className="absolute w-11 p-2 flex items-center justify-center h-11 bottom-4 right-4 z-[2] bg-white shadow rounded border border-solid border-black/5"
      >
        <img
          className="w-10 h-10 aspect-square"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAVUlEQVR4nGNgGAUkAg8GBobHDAwM/9EwLoCu7hHUDJzgERZN//Gox6YWZAZBDeSC/4T0j1rwn8IgHgWjgAgwmtH+D3hZ9IjWxbUHDkuoVuGMAgZ0AADoT0vu2C9MdgAAAABJRU5ErkJggg=="
        />{" "}
      </button>

      {modal && (
        <div className="fixed top-0 left-0 right-0 w-full h-full z-20 bg-white">
          <div className="relative w-full h-full">
            <model-viewer
              src={url}
              poster={imageUrl}
              shadow-intensity="1"
              ar
              camera-controls
              touch-action="pan-y"
              alt={title}
            ></model-viewer>
            <button
              onClick={() => openModal(false)}
              className="absolute w-11 p-2 flex items-center justify-center h-11 bottom-4 right-4 z-[2] bg-white shadow rounded border border-solid border-black/5"
            >
              <img
                className="w-10 h-10 aspect-square"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAYAAACOqiAdAAAACXBIWXMAAAsTAAALEwEAmpwYAAACCUlEQVR4nO3bz07bQBDH8T3RG/RUOJfQgw+Jd8aOj6V3eBFQ36iIt+HPc5BjQYJK5RJENcpGQikHe1hskXw/km8Zz/onJdJO1iEAAAAAAAC8RV3X32KMx03T7HattRqrLcvyIGwSVf2pqk+q+iwiD6p62KH2h6r+SbVzETkNm2A0Gn0SkUd78BfXZdt6Ebl+WSsif+2eYd2p6v5KaPbwv9vW22dX6+2eYd3FGEevBHfbtt4+u1pv9wzrLhKcD8E5EZwTwTkRnBPBORGcE8E5EZwTwYXFhr2qqq9drjTdyLrlsnt2XUdRFFthqNGQ/D/lcF0ZgvP0fOx9JFWW5cFynvZRg1vO83odEMQYj3MtPj3ATdveqjrL3Pso9KVpmt00uc21+F9te4vIWca+9+Px+Evok6oe2uQ2fXXunNfMQptOp9sd+u6k8GbevmnNF1VVfX/flAAAAADARRdztasMWy7bPu207TuZTD6r6nmGLddll1NSWdR1vZd5k3/WtncKLVffB8/5PLfIWMk/yBSR+ToMMns/IiYip3ao76MGZ2sXkZMwhKIotvizpieR83E+BOdEcE4E50RwTgTnRHBOBOdEcE4E50RwTrwEl/e1y4u29TZ1Xp1yDHa6sm+yGEnNl0etupwasnH3cvqcXvQdZjQ05G+diBx5zqdZjdVuxHuqAAAAAAAgvKt/mSudWti0b4oAAAAASUVORK5CYII="
              />{" "}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThreeDModal;
